import { Component, inject } from '@angular/core';
import { TransportFormService } from 'src/app/trip-calculator/services/transport-form.service';
import { AirportFormComponent } from '../airport-form/airport-form.component';
import { TIMFormComponent } from '../tim-form/tim-form.component';
import { InputTextModule } from 'primeng/inputtext';
import { AddressFormComponent } from '../address-form/address-form.component';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { InputNumberModule } from 'primeng/inputnumber';
import { ErrorComponent } from '../../../error/error.component';
import { TranslocoPipe } from '@jsverse/transloco';
import { CheckboxModule } from 'primeng/checkbox';
import { SelectButtonModule } from 'primeng/selectbutton';
import { ScheduledDaysSelectorComponent } from '../../../custom-input/scheduled-days-selector/scheduled-days-selector.component';
import { CruiseFormComponent } from '../cruise-form/cruise-form.component';
import { TransportDurationFormComponent } from '../duration-form/duration-form.component';
import { DistanceFormComponent } from '../distance-form/distance-form.component';
import { TooltipIconComponent } from 'src/app/shared/tooltip-icon/tooltip-icon.component';
import { TripService } from 'src/app/trip-calculator/services/trip.service';

@Component({
  selector: 'app-transport-form',
  imports: [
    AirportFormComponent,
    TIMFormComponent,
    TransportDurationFormComponent,
    InputTextModule,
    DistanceFormComponent,
    AddressFormComponent,
    ReactiveFormsModule,
    InputNumberModule,
    ErrorComponent,
    TranslocoPipe,
    CheckboxModule,
    SelectButtonModule,
    ScheduledDaysSelectorComponent,
    CruiseFormComponent,
    TooltipIconComponent,
  ],
  templateUrl: './transport-form.component.html',
})
export class TransportFormComponent {
  transportFormService = inject(TransportFormService);
  tripService = inject(TripService);
  get numberOfVehicleControl() {
    return this.transportFormService.transportForm.get(
      'numberOfVehicle',
    ) as FormControl;
  }
  MAX_PASSENGERS_FOR_PRIVATE_BUS = 60;

  get displayPrivateBusWarning() {
    const numberOfVehicle = this.numberOfVehicleControl.value;
    const totalTravellers = this.tripService.trip()?.travellers;
    if (numberOfVehicle && totalTravellers) {
      return (
        totalTravellers / this.MAX_PASSENGERS_FOR_PRIVATE_BUS > numberOfVehicle
      );
    }
    return false;
  }
}
